import Api from '../../../helpers/Api';

export const SET_SPOT_DATA = 'SET_SPOT_DATA';
const setSpotData = (spotSlug, spotData) => ({
    type: SET_SPOT_DATA,
    spotSlug: spotSlug || '',
    spotData: spotData || {},
});

export const SET_SPOT_MODAL_OPEN = 'SET_SPOT_MODAL_OPEN';
export const setSpotModalOpen = (spotModalOpen) => ({
    type: SET_SPOT_MODAL_OPEN,
    spotModalOpen,
});

export const SET_IS_LOADING_SPOT_DATA = 'SET_IS_LOADING_SPOT_DATA';
const setIsLoadingSpotData = (isLoading) => ({
    type: SET_IS_LOADING_SPOT_DATA,
    isLoading,
});

export const getSpotDataIfNeeded = (spotSlug) => (dispatch, getState) => {
    const { spotSlug: currentSpotSlug } = getState().spot;

    if (currentSpotSlug !== spotSlug) {
        const query = `api/v1/getSpotData/${spotSlug}`;

        dispatch(setIsLoadingSpotData(true));

        // Reset the current data, if any
        dispatch(setSpotData());

        return Api.progressGet(dispatch, query)
            .then((json) => {
                if (json.status !== 'success') {
                    throw 'error from server';
                } else {
                    dispatch(setSpotData(spotSlug, json.data));
                }
            }).catch((err) => {
                // eslint-disable-next-line no-console
                console.error(err);
            }).finally(() => dispatch(setIsLoadingSpotData(false)));
    }

    return Promise.resolve();
};

export const showSpotModal = (spotSlug) => (dispatch) => {
    dispatch(setSpotModalOpen(true));

    dispatch(getSpotDataIfNeeded(spotSlug));
};
